import {UserHeader} from '../../partials/user_menu';

window.addEventListener('load', () => UserHeader.onload());
